import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Alert, Button, Card } from "flowbite-react";
import Input from "../inputs/Input";
import AutoCompleteInput from "../inputs/Autocomplete";
import ComunicateSellSection from "./ComunicateSellSection";
import * as yup from "yup";
import { useEffect, useState } from "react";
import axios from "axios";
import CurrencyInput from "../inputs/CurrencyInput";

const schema = yup.object().shape({
  dataVenda: yup
    .string()
    .required("A data é obrigatória")
    .test("data-valida", "A data deve ser uma data válida", (value) => {
      return !!value && !isNaN(Date.parse(value));
    })
    .test(
      "data-nao-futura",
      "A data não pode ser depois da data atual",
      (value) => {
        if (!value) return false;
        const dataInformada = new Date(value);
        const hoje = new Date();
        // Zera os horários para comparar apenas a data
        dataInformada.setHours(0, 0, 0, 0);
        hoje.setHours(0, 0, 0, 0);
        return dataInformada <= hoje;
      }
    ),
  ufVenda: yup.string().required("A UF é obrigatória"),
  codigoMunicipioVenda: yup.string().required("O município é obrigatório"),
  valorVenda: yup
    .number()
    .transform((value, originalValue) =>
      typeof originalValue === "string" && originalValue.trim() === ""
        ? null
        : value
    )
    .required("O preço da venda é obrigatório")
    .min(0, "O preço não pode ser negativo"),
});

const SellData = ({
  setActiveStep,
  communicateSell,
  setCommunicateSell,
  states,
  isSubmitting,
}) => {
  const [error, setError] = useState(null);
  const [municipios, setMunicipios] = useState([]);
  const [isLoadingMunicipios, setIsLoadingMunicipios] = useState(false);

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    if (communicateSell) {
      Object.keys(communicateSell).forEach((s) => {
        setValue(s, communicateSell[s]);
      });
    }
  }, [communicateSell, setValue]);

  useEffect(() => {
    setIsLoadingMunicipios(true);
    const getMunicipios = async () => {
      const response = await axios.get(
        `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${watch(
          "ufVenda"
        )}/municipios?orderBy=nome`
      );

      setMunicipios(
        response?.data?.map((municipio) => ({
          value: municipio.id,
          label: municipio.nome,
        }))
      );
      setIsLoadingMunicipios(false);
    };

    getMunicipios();
  }, [watch("ufVenda")]);

  const onBack = async () => {
    setActiveStep(1);
  };

  const onSubmit = async (data) => {
    setCommunicateSell((prev) => ({ ...prev, ...data }));
    setActiveStep(3);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <ComunicateSellSection name="Dados da venda">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <Input
              register={register}
              name="dataVenda"
              label="Data da venda *"
              type="date"
              required={true}
            />
            {errors.dataVenda?.message && (
              <small className="text-red-600">
                {errors.dataVenda?.message}
              </small>
            )}
          </div>

          <div>
            <CurrencyInput
              register={register}
              name="valorVenda"
              label="Valor da venda *"
              required={true}
              control={control}
            />
            {errors.valorVenda?.message && (
              <small className="text-red-600">
                {errors.valorVenda?.message}
              </small>
            )}
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
          <div>
            <AutoCompleteInput
              register={register}
              name="ufVenda"
              label="UF da Venda *"
              options={states}
              value={watch("ufVenda")}
              onChange={(user) => setValue("ufVenda", user.value)}
              required={true}
            />
            {errors.ufVenda?.message && (
              <small className="text-red-600">{errors.ufVenda?.message}</small>
            )}
          </div>

          <div>
            <AutoCompleteInput
              register={register}
              name="codigoMunicipioVenda"
              label="Município da venda *"
              options={municipios}
              value={watch("codigoMunicipioVenda")}
              onChange={(user) => setValue("codigoMunicipioVenda", user.value)}
              required={true}
              isLoading={isLoadingMunicipios}
            />
            {errors.codigoMunicipioVenda?.message && (
              <small className="text-red-600">
                {errors.codigoMunicipioVenda?.message}
              </small>
            )}
          </div>
        </div>
      </ComunicateSellSection>

      <div className="flex justify-center items-center gap-2 mt-10">
        <Button
          className="bg-gray-500"
          onClick={onBack}
          style={{ minWidth: "90px" }}
        >
          Voltar
        </Button>
        <Button
          type="submit"
          className="primary"
          disabled={isSubmitting}
          isProcessing={isSubmitting}
        >
          {!isSubmitting ? "Próximo" : "Salvando..."}
        </Button>
      </div>
      {error && (
        <Alert color="failure" withBorderAccent className="mt-4">
          Erro ao tentar salvar o laudo! Tente novamente mais tarde.
        </Alert>
      )}
    </form>
  );
};

export default SellData;
